module.exports = __webpack_public_path__ + "img/case-logo-18.c78413b8.png";